<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="IAAtdSetting">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class=" d-flex align-items-center">
                                            <img alt="Logo" src="../../assets/img/attendance.png" class="mh-45px pb-2">
                                            <p class="mb-1">
                                                <span class="main-content-label"><b>Practical Attendance Threshold</b></span><br>
                                                <span class="text-muted card-sub-title mb-0">List Of Practical
                                                    Attendance Threshold</span>
                                            </p>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="row clearfix mt-2">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                            formControlName="SessionId">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo"  (click)="SetSession(item.SnNo)">
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>College</mat-label>
                                                        <mat-select #select233 placeholder="college" class="colorblack"
                                                            formControlName="CgCode">
                                                            <mat-select-filter *ngIf="select233.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode" (click)="getCourse(item.CgCode)">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Course</mat-label>
                                                        <mat-select #select23 placeholder="Course" class="colorblack"
                                                            formControlName="CoCode">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode" (click)="getExam(item.CoCode)">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Exam</mat-label>
                                                        <mat-select #select234 placeholder="Exam" class="colorblack"
                                                            formControlName="EmId">
                                                            <mat-select-filter *ngIf="select234.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="ExamList"
                                                                (filteredReturn)="filteredListExam =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.EmId" (click)="getExmSub(item)">
                                                                {{item.EmCode}} - {{item.EmName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="col-sm-3" *ngIf="BranchShow">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Branch</mat-label>
                                                        <mat-select #select235 placeholder="Branch" class="colorblack"
                                                            formControlName="StrId">
                                                            <mat-select-filter *ngIf="select235.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'StrName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getBrSub(item.StrId)">
                                                                {{item.StrCode}} - {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Subject
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CoCode"
                                                            formControlName="EsParentId" >
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="subjectList"
                                                                (filteredReturn)="filteredsubjectList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredsubjectList"
                                                                [value]="item.EsId" (click)="ShowTable(item.EsId,item.EsCode)">
                                                             {{item.EsCode}}-{{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        

                                        <div *ngIf="Table" class="table-responsive sccc mt-4">
                                            <div class="container">
                                                <table  class="table  table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th class="f600" width="8%">
                                                                Sr.No
                                                            </th>
                                                            <th class="f600">
                                                                Practical Code
                                                            </th>
                                                            <th class="f600">
                                                                Practical Name
                                                            </th>
                                                            <th class="f600">
                                                                Attendance
                                                            </th>
                                                            <th hidden>
                                                                EsId
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="StuArray">
                                                        <tr  *ngFor="let markData of getStuArrayControls(); let i = index" 
                                                        [formGroupName]="i">
                                                        <td>
                                                            <input readonly class="tab2 form-control input-sm"
                                                            formControlName="SrNo">
                                                        </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm"
                                                                formControlName="EsCode">
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm"
                                                                formControlName="EsName">
                                                            </td>
                                                            <td>
                                                                <input class="tab3 form-control text-center" id="EsName" formControlName="Attendance" maxlength="3"
                                                                    (keyup)="onInputChange2($event,i)">
                                                                <mat-error class="margin_tp mrgtp"
                                                                    *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.PercentError">
                                                                    Enter Less Than 100%
                                                                </mat-error>
                                                                <mat-error class="margin_tp mrgtp"
                                                                    *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.NonNumericError">
                                                                    Invalid
                                                                </mat-error>
                                                                <mat-error class="margin_tp mrgtp"
                                                                    *ngIf="markData.controls.Attendance.touched && markData.controls.Attendance.errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </td>
                                                            <td hidden>
                                                                <input readonly class="tab2 form-control input-sm"
                                                                formControlName="EsId">
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                           
                                        </div>
                                        <div class="col-sm-12 mb-3">
                                           
                                            <button  type="button"
                                                class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                (click)="Save()" *ngIf="SaveBtn && IaAtdCreate" [disabled]="saveDisable">
                                                <!-- && AtdSettingCreate -->
                                                <span style="display: contents; align-items: center;">
                                                    <img width="15vh" src="../../assets/img/save.gif"
                                                        style="margin-right: 7px;">
                                                        Save
                                                </span>
                                            </button>
                                            <!-- && AtdSettingUpdate -->
                                            <button *ngIf="UpdateBtn && IaAtdUpdate" type="button"
                                            
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                            (click)="update()" [disabled]="updateDisable">
                                            <span style="display: contents; align-items: center;">
                                                <img width="15vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 7px;">
                                                    Update
                                            </span>
                                        </button>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>
